import Image from 'next/image';
import Link from 'next/link';
import HomepageHeader from '@/components/HomepageHeader';
import HomepageFooter from '@/components/HomepageFooter';

export default function SearchProcess() {
  return (
    <div className="min-h-screen bg-[#F6EFED] page-transition">
      {/* Header Component */}
      <HomepageHeader />

      {/* Hero Search Section */}
      <section className="bg-[#f6efed] pt-[180px] pb-[100px]">
        <div className="max-w-[1400px] mx-auto px-[20px] text-center">
          <h1 className="font-['Gotham_Rounded',sans-serif] text-[48px] font-bold text-[#2E2A3A] leading-[56px] mb-6">
            Find Verified Women-Only Fitness Near You
          </h1>
          <p className="font-['Archivo',sans-serif] text-[18px] font-normal text-[#000000] leading-[36px] tracking-[3%] mb-10 max-w-3xl mx-auto">
            Discover safe, women-only gyms, studios activities customised for your comfort and privacy.
          </p>

          {/* Search Form */}
          <div className="flex gap-4 max-w-4xl mx-auto items-center">
            {/* Location Input */}
            <div className="flex-1 relative">
              <div className="absolute left-4 top-1/2 -translate-y-1/2">
                <svg className="w-5 h-5 text-[#6e6672]" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                </svg>
              </div>
              <input
                type="text"
                placeholder="Enter postcode or area"
                className="w-full pl-12 pr-4 py-4 bg-white border border-[#e8e1e6] rounded-[10px] text-[#2b262e] text-[16px] placeholder:text-[#a0969e] outline-none focus:ring-2 focus:ring-[#8A7296] focus:border-transparent transition-all font-['Archivo',sans-serif]"
              />
            </div>

            {/* Activity Dropdown */}
            <select className="px-6 py-4 bg-white border border-[#e8e1e6] rounded-[10px] text-[#2b262e] text-[16px] outline-none focus:ring-2 focus:ring-[#8A7296] focus:border-transparent transition-all font-['Archivo',sans-serif]">
              <option>Select Activity</option>
              <option>Gym</option>
              <option>Yoga</option>
              <option>Pilates</option>
              <option>Boxing</option>
              <option>Swimming</option>
            </select>

            {/* Search Button */}
            <button className="px-[38px] py-[18px] bg-[#8A7296] hover:bg-[#7a647d] text-white rounded-[10px] transition-colors inline-flex items-center gap-2 font-['Archivo',sans-serif] text-[16px] font-medium">
              Search
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </button>
          </div>
        </div>
      </section>

      {/* Main Content - Placeholder */}
      <main className="bg-[#f6efed] py-[100px]">
        <div className="max-w-[1400px] mx-auto px-[20px]">
          <div className="text-center">
            <h2 className="font-['Gotham_Rounded',sans-serif] text-[48px] font-bold text-[#2E2A3A] leading-[56px] mb-8">
              How to Search
            </h2>
            <p className="font-['Archivo',sans-serif] text-[18px] font-normal text-[#000000] leading-[36px] tracking-[3%] max-w-3xl mx-auto">
              Content coming soon...
            </p>
          </div>
        </div>
      </main>

      <HomepageFooter />
    </div>
  );
}
